import type { PresetOption } from '@dealstack/frontend/shared/components/EmailTemplates/utils/inspectorPresets';

interface Props {
	label: string;
	options: PresetOption[];
	value: string;
	onChange: (value: string) => void;
}

// A native select: a portalled trigger in this sidebar drops the editor's node
// selection on click, collapsing the panel back to the document root.
export const PresetRow = ({ label, options, value, onChange }: Props) => (
	<div data-re-inspector-prop-row="">
		<label data-re-inspector-label="">{label}</label>
		<select
			data-re-inspector-select=""
			aria-label={label}
			value={value}
			onChange={(event) => onChange(event.currentTarget.value)}
		>
			{options.map((option) => (
				<option key={option.value} value={option.value}>
					{option.label}
				</option>
			))}
		</select>
	</div>
);
